import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_127_vendors: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    loadApiName: "supplier_summary",
    fabAction: {
      type: "add",
      screenId: "128",
      action: "modulev1/supplier_add",
    },
    title: "Vendors",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "code",
            Name: "supplier_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/supplier_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "128",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "supplier_summary",
                },
                ActionType: "Delete",
                ScreenId: "128",
              },
            ],
            Form: {
              Name: "supplier_summary",
              TableName: "supplier_details",
              DisplayName: "Supplier Details",
              View: "view_supplier_summary",
              Filter:
                "view_supplier_summary.soft_delete=0 order by view_supplier_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Code",
                  BindValue: "vin_number",
                  Json_Attribute: "code",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  IsMandatory: true,
                  BindValue: "txt_suppliername",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Mobile",
                  IsMandatory: true,
                  BindValue: "numeric_suppliermobile",
                  Json_Attribute: "suppliermobile",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor address",
                  IsMandatory: true,
                  BindValue: "txt_supplieraddress",
                  Json_Attribute: "supplieraddress",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT certificate",
                  BindValue: "vat_certificate_attachment",
                  Json_Attribute: "vat_certificate_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit application form",
                  BindValue: "credit_application_form_attachment",
                  Json_Attribute: "credit_application_form_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Trade license",
                  BindValue: "trade_license_attachment",
                  Json_Attribute: "trade_license_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Others attachment",
                  BindValue: "Others_attachment",
                  Json_Attribute: "Others_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                // {
                //   IncludeLabel: true,
                //   Label: "Total.dr",
                //   IsMandatory: true,
                //   BindValue: "txt_totdr",
                //   Json_Attribute: "",
                //   componentType: ComponentType.TEXT_FIELD,
                //   showInSummary: true,
                // },
                // {
                //   IncludeLabel: true,
                //   Label: "Total.cr",
                //   IsMandatory: true,
                //   BindValue: "txt_totcr",
                //   Json_Attribute: "",
                //   componentType: ComponentType.TEXT_FIELD,
                //   showInSummary: true,
                // },
              ],
            },
          },
        ],
      },
    ],
  },
];
